import rawEmojis from './rawEmojis';

/**
 * Emoji enum.  Keys are shortcodes.  Values are emojis.
 */
export const EMOJI_SHORTCODE = Object.fromEntries(
  Object.entries(
    rawEmojis.reduce((o, e) => {
      // Some emojis have several variations.  We want to use the emoji with simplest variation (shortest hexcode).
      if (!o[e.shortcode] || e.hexcode.length < o[e.shortcode].hexcode.length) {
        // eslint-disable-next-line no-param-reassign
        o[e.shortcode] = e;
      }
      return o;
    }, {})
  ).map(([shortcode, { unicode }]) => [shortcode, unicode])
);

/**
 * Emoji enum.  Keys are emoticons.  Values are emojis.
 */
export const EMOTICON = Object.fromEntries(
  rawEmojis.filter((e) => e.emoticon).map(({ emoticon, unicode }) => [emoticon, unicode])
);

/**
 * Emoji enum.  Keys are emojis.  Values are shortcodes.
 */
export const EMOJI = rawEmojis.reduce((o, e) => {
  const shortcode = `:${e.shortcode}:`;
  // Some emojis have several shortcodes.  We want to use the shortest one.
  if (!o[e.unicode] || shortcode.length < o[e.unicode].length) {
    // eslint-disable-next-line no-param-reassign
    o[e.unicode] = shortcode;
  }
  return o;
}, {});
